export default function isDateTodayOrInFuture(value) {
    var _a = value.split('.'), day = _a[0], month = _a[1], year = _a[2];
    var date = new Date(Number(year), Number(month) - 1, Number(day));
    date = new Date(date.getTime() + Math.abs(date.getTimezoneOffset() * 60000));
    return date.getTime() >= new Date().setHours(0, 0, 0);
}
